import { DialogOpenEvent } from '@theme/dialog';

/**
 * Handles the VANYA search drawer category dropdown and dialog UX.
 */
class SearchDrawerCategory extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.label = this.querySelector('[data-category-label]');
    this.form = this.closest('form');
    this.buttons = this.querySelectorAll('[data-category-value]');

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', this.#onSelect);
    });

    document.addEventListener('click', this.#onOutsideClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onOutsideClick);
  }

  #onSelect = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const value = button.dataset.categoryValue ?? '';
    const label = button.textContent?.trim() ?? '';

    if (this.label) {
      this.label.textContent = label;
    }
    if (this.details) {
      this.details.open = false;
    }

    if (!this.form) return;

    const defaultAction = this.form.dataset.defaultAction || '/search';

    if (value) {
      const root = window.Shopify?.routes?.root || '/';
      this.form.action = `${root}collections/${value}`;
    } else {
      this.form.action = defaultAction;
    }
  };

  #onOutsideClick = (event) => {
    if (!(event.target instanceof Node) || !this.contains(event.target)) {
      if (this.details) this.details.open = false;
    }
  };
}

if (!customElements.get('search-drawer-category')) {
  customElements.define('search-drawer-category', SearchDrawerCategory);
}

/**
 * Focus search input when the drawer opens.
 */
function initSearchDrawerFocus() {
  const drawer = document.getElementById('search-drawer');
  const input = document.getElementById('search-drawer-input');

  if (!drawer || !input) return;

  drawer.addEventListener(DialogOpenEvent.eventName, () => {
    requestAnimationFrame(() => {
      input.focus();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchDrawerFocus);
} else {
  initSearchDrawerFocus();
}
